import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { prefetchSystemsGridViewAndForm, systemGridPageRoutes } from "./SystemsGridPage";

export const route: NavigationItemType["route"] = { path: "systems", children: systemGridPageRoutes };
export const to = (paths: Paths) => paths.systemsGrid();

export const prefetch = prefetchSystemsGridViewAndForm;
